module.exports = __webpack_public_path__ + "static/img/ux_content.f2612c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/ux_content.png
// module id = cOVr
// module chunks = 23